module.exports = __webpack_public_path__ + "static/media/loadboy.dfe4469b.svg";